import { render, staticRenderFns } from "./CorrectDemand.vue?vue&type=template&id=d8ddd37a&scoped=true&"
import script from "./CorrectDemand.vue?vue&type=script&lang=js&"
export * from "./CorrectDemand.vue?vue&type=script&lang=js&"
import style0 from "./CorrectDemand.vue?vue&type=style&index=0&id=d8ddd37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ddd37a",
  null
  
)

export default component.exports